export default __webpack_public_path__ + "static/media/Settings.dba6f53d.svg";